import React from 'react';
import Header from './Header';
import about from '../json/about.json';

function About() {
	return (
		<React.Fragment>
			<Header appTitle="About" />
			<div className="main-body about-page pd-md-v xl-pd-none">
				
				<div className="about">
					{about.map((info, index) => (
						<div key={index} className="each-about elevate bg-light pd-md sp-xl-h">
							<h2 className="txt-primary font-bold">{info.title}</h2>
							<p className="sp-top" dangerouslySetInnerHTML={{ __html: info.description }} />
						</div>
					))}
				</div>
				<div className="truth-table elevate">
					<h2 className="pd-md txt-primary font-bold ln-bottom">Truth Table</h2>
					<div className="full bg-light">
						{[
							{
								key: 'Official Names',
								value: 'Michael Aloo',
							},
							{
								key: 'Other Names',
								value: 'Aim Mikel',
							},
							{
								key: 'Nationality',
								value: 'Kenyan',
							},
							{
								key: 'Languages',
								value: 'English, Kiswahili, Luo',
							},
							{
								key: 'Hair Color',
								value: 'Black',
							},
							{
								key: 'Skin Complexion',
								value: 'Black',
							},
							{
								key: 'Year Of Birth',
								value: '1997',
							},
							{
								key: 'Height',
								value: '187 cm',
							},
							{
								key: 'Weight',
								value: '187 pounds',
							},
							{
								key: 'Religion',
								value: 'Christian',
							},
							{
								key: 'Marital Status',
								value: 'Complicated',
							},
							{
								key: 'Favorite Color',
								value: 'Blue',
							},
							{
								key: 'Favorite Food',
								value: 'Beef stew with Minji and Chapati',
							},
							{
								key: 'Favorite Singers',
								value: 'Hillsong, Passenger',
							},
							{
								key: 'Favorite Songs',
								value: 'Broken Vessels - Hillsong, Home - Passenger',
							},
							{
								key: 'Favorite Movie',
								value: 'Five Feet Apart',
							},
							{
								key: 'Favorite Car',
								value: 'BMW X5',
							},
							{
								key: 'Favorite IDEs',
								value: 'Android Studio, IntelliJ, VSCodium, Netbeans',
							},
							{
								key: 'Favorite OS',
								value: 'Parrot - Linux',
							},
							{
								key: 'Hero',
								value: 'Elon Musk',
							},
							{
								key: 'Hobbies',
								value: 'Playing Video Games, Listening to Music',
							},
							{
								key: 'Favorite Quote',
								value: 'Genius is 1% talent and 99% hard work - Albert Einstein',
							},
							{
								key: 'Pet',
								value: 'Dog',
							},
						].map((data, index) => (
							<div key={data.key} className="flex each-truth">
								<section className="title pd font-bold">{data.key}</section>
								<section className="flex-grow pd">{data.value}</section>
							</div>
						))}
					</div>
				</div>
				<div className="blob-t blob-b pd-md-h txt-fade sp-xl-top">
					<i>
						If in any case or for trust purposes or for job purposes a need for my Curriculum Vitae (CV) arises, you can contact me via the links I have provided in the contact section for one. <b>Please do this for official purposes only</b> .
					</i>
				</div>
			</div>
		</React.Fragment>
	);
}

export default About;
